import React, { ReactElement, PropsWithChildren } from 'react';
import classnames from 'classnames';
import './index.css';

export type LabelColours =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'info'
  | 'warning-alt'
  | 'warning'
  | 'danger'
  | 'dark'
  | 'light';

type LabelSizes = 'tiny' | 'small' | 'default' | 'large';

export type LabelProps = PropsWithChildren<{
  bordered?: boolean;
  className?: string;
  colour?: LabelColours;
  size?: LabelSizes;
  testId?: string;
}>;

export function Label({
  bordered = false,
  children,
  className = '',
  colour = 'primary',
  size = 'default',
  testId = '',
}: LabelProps): ReactElement {
  const classes = classnames('label', {
    [className]: !!className,
    [`label--bordered`]: bordered,
    [`label--${colour}`]: colour !== 'primary',
    [`label--${size}`]: size !== 'default',
  });

  return (
    <span className={classes} data-testid={testId}>
      {children}
    </span>
  );
}
